var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex number-input-wrapper",class:{ hasUnit: _vm.unit }},[_c('vs-input',{staticClass:"w-full",attrs:{"value":_vm.value,"type":"number","disabled":_vm.disabled},on:{"input":_vm.handleInput,"keypress":_vm.isNumber,"change":function($event){return _vm.$emit('change', $event.target.value)}}}),(_vm.unit)?_c('div',{staticClass:"py-2 border border-l-0 border-solid rounded-r right-side-input whitespace-no-wrap",class:[
      {
        'px-1': _vm.compact,
      },
      {
        'px-3': !_vm.compact,
      },
      {
        disabled: _vm.disabled,
      },
    ]},[_vm._v("\n    "+_vm._s(_vm.unit)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }